import { useQuery } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import { adminUserKeys } from './queryKeys';

export const useAdminUserLoginAttempts = (
  adminUserId: string | null,
  page: number,
  pageSize: number,
) => {
  return useQuery({
    queryKey: adminUserKeys.loginAttempts(adminUserId ?? '0', { page, pageSize }),
    queryFn: async () => {
      const response = await adminUsersApi.getLoginAttempts(adminUserId!, { page, pageSize });
      return response.data;
    },
    enabled: adminUserId !== null,
    // Access history must be fresh every time the detail is opened — never serve stale cache.
    staleTime: 0,
    refetchOnMount: 'always',
    placeholderData: (prev) => prev,
  });
};
